<template>
  <div class="main-video">
    <Subtitle>Обучение</Subtitle>
    <div class="main-video-content">
      <div :key="video.title" v-for="video in videos">
        <main-text class="main-video-title">{{ video.title }}</main-text>
        <b-embed type="iframe" aspect="16by9" :src="video.src" allowfullscreen />
      </div>
    </div>
  </div>
</template>

<script>
import Subtitle from "./ui/Subtitle.vue";
import Text from "./ui/Text.vue";

export default {
  props: {
    videos: {
      type: Array,
      require: true,
    },
  },
  components: {
    Subtitle,
    "main-text": Text,
  },
};
</script>

<style scoped>
.main-video-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 19px;
  margin-top: 16px;
}
.main-video-title {
  margin-bottom: 8px;
}
</style>
